import { axios } from '@Root/API'

export const getAccommodation = () => {
  return axios.get('accommodations/list')
}
